import React from "react";
import Sidebar from "../../components/commons/Sidebar";
import Portofolio from "../../components/admin/portofolio/portofolio";

const CertificateT = () => {
  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      <Sidebar />
      <div className="flex-1 overflow-x-auto">
        <Portofolio />
      </div>
    </div>
  );
};

export default CertificateT;
